var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"/","title":"cssoftshop - Главная"}},[_c('img',{staticClass:"logo",attrs:{"alt":"logo","title":"Чит для кс го","src":require("../assets/img/logo_modern.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }